import { useCallback, useEffect, useRef, useState } from 'react';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import Form from 'devextreme-react/form';

import { t } from 'i18next';
import { IParameterDefinition } from '@/core/interfaces/admin/usestate-interfaces';
import { languageService } from '@/core/services/language-service';
import { parameterService } from '@/projects/admin/services/parameter-service';
import { applicationService } from '@/projects/admin/services/application-service';
import DataSource from 'devextreme/data/data_source';
import { useNavigate, useParams } from 'react-router-dom';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const store = new DataSource({});
const ParameterDefinition = (props: any) => {
  const params = useParams();
  const parameterId = params.id;
  const [parameter, setParameter] = useState<IParameterDefinition>({ id: '', applicationId: '', parentId: '', code: '', translates: [] });
  const [languages, setLanguages] = useState([{ id: '', description: '', flagUrl: '', order: null }]);



  const handleSubmit = useCallback(async (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        const parameterForm = formRef.current.props.formData;

        parameterForm.id = parameterId;
        const elements = document.getElementsByClassName("languages");

        if (parameterForm.id) {
          Array.from(elements).map((item, index) => {
            if (!('languageId' in parameterForm.translates)) {
              const id = item.className.split(" ")[0];
              parameterForm.translates[index].languageId = id;
            }
            parameterForm.translates[index].longDescription = parameterForm.translates[index].description;

          });
          await parameterService.updateParameter(null, parameterForm)
        } else {
          Array.from(elements).map((item, index) => {
            const id = item.className.split(" ")[0];
            parameterForm.translates[index].languageId = id;
            parameterForm.translates[index].longDescription = parameterForm.translates[index].description;
          });
          if (parameterForm.parentId === '')
            delete parameterForm.parentId;
          await parameterService.createParameter(parameterForm)

        }
        store.reload();
        resolve();
      } catch (error) {
        reject(error)
      }

    })
  }, []);

  const formRef: any = useRef<Form>();
  useEffect(() => {
    (async function () {
      if (typeof parameterId !== "undefined") {
        const getParameter = await parameterService.getParameter(parameterId);
        const data = getParameter.data;
        const getParameterTranslate = await parameterService.getParameterTranslate(parameterId);
        const parameterTranslateData = getParameterTranslate.data;
        setParameter({
          id: data.id,
          applicationId: data.applicationId,
          parentId: data.parentId,
          code: data.code,
          translates: parameterTranslateData
        });
      }
    })();
  }, [])
  useEffect(() => {
    const fetchLanguages = async () => {
      const languages = await languageService.getLanguages({});
      setLanguages(languages.data);
    };
    fetchLanguages();

  }, [])

  const [parentParameters] = useState(() => createCustomStore({
    key: 'id',
    load: parameterService.getParentParameters,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["id", "=", key];
      }
    }
  }));

  const [applications] = useState(() => createCustomStore({
    key: 'id',
    load: applicationService.lookupApplication,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  }));



  const parentParameterEditorOptions = {
    inputAttr: { [ELEMENT_ID]: 'parentParameters' },
    dataSource: parentParameters,
    displayExpr: 'name',
    valueExpr: 'id',
    placeholder: t('select_parameter'),
  };
  const applicationsEditorOptions = {
    inputAttr: { [ELEMENT_ID]: 'applications' },
    dataSource: applications,
    displayExpr: 'name',
    valueExpr: 'id',
    placeholder: t('select_application'),
  };
  const codeEditorOptions = {
    inputAttr: { [ELEMENT_ID]: 'code' },
  };

  return (
    <FormWrapper
      onSubmit={handleSubmit}
      formRef={formRef}
      formData={parameter}
      backButtonNavigationPath='/admin/parameters'
      buttonGroups={[
        { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
      ]}
      simpleItemGroups={[
        {
          caption: t('new_parameter'),
          useColCountByScreen: true,
          items: [
            {
              dataField: 'applicationId',
              editorType: 'dxSelectBox',
              editorOptions: applicationsEditorOptions,
              label: t('application'),
              isRequired: true,
              requiredMessage: t('application')
            },
            {
              dataField: 'parentId',
              editorType: 'dxSelectBox',
              editorOptions: parentParameterEditorOptions,
              label: 'Parent',
            },
            {
              dataField: 'code',
              editorType: 'dxTextBox',
              editorOptions: codeEditorOptions,
              label: t('code'),
              isRequired: true,
              requiredMessage: t('code')
            },
            ...languages.map((language, index) => ({
              dataField: `translates[${index}].description`,
              cssClass: `${language.id} languages`,
              label: `${language.description} ${t('definition')}`,
              isRequired: true,
              requiredMessage: `${language.description} ${t('definition')} is required`,
            }))
          ]
        }
      ]}
    />
  )
}

export default ParameterDefinition;